// settings strings (ar). Machine-drafted — review with a native speaker before launch.
const settings = {
	settings: {
		// Settings sidebar nav
		nav_yourProfile: 'ملفك الشخصي',
		nav_billing: 'الفوترة',
		nav_generateZapierKey: 'إنشاء مفتاح Zapier',
		nav_generateIntegrationKey: 'إنشاء مفتاح التكامل',
		nav_mcp: 'مساعدو الذكاء الاصطناعي (MCP)',
		nav_referEarn: 'أحِل واربح',
		nav_manageWorkspaces: 'إدارة مساحات العمل',
		nav_emailAccounts: 'حسابات البريد الإلكتروني',
		nav_basicSettings: 'الإعدادات الأساسية',
		nav_teamMembers: 'أعضاء الفريق',
		nav_previewCard: 'معاينة البطاقة',
		nav_workspaceDomain: 'نطاق مساحة العمل',
		nav_videoCards: 'بطاقات الفيديو',
		nav_customDomainSettings: 'إعدادات النطاق المخصص',
		nav_personalization: 'التخصيص',
		section_accountSettings: 'إعدادات الحساب',
		section_workspaceSettings: 'إعدادات مساحة العمل',
		section_whiteLabelSettings: 'إعدادات العلامة البيضاء',

		// Shared dialog titles / statuses
		title_success: 'نجاح',
		title_error: 'خطأ',
		title_oops: 'عذرًا!',
		title_warning: 'تحذير',
		title_sorry: 'آسف',
		uploading: 'جارٍ الرفع...',

		// Basic Settings
		basicDetailsTitle: 'التفاصيل الأساسية',
		workspaceImageUpdated: 'تم تحديث صورة مساحة العمل.',
		workspaceName: 'اسم مساحة العمل',
		timeZone: 'المنطقة الزمنية',
		saveUpdate: 'حفظ وتحديث',
		noWorkspace: 'ليس لديك حاليًا أي مساحة عمل',
		nothingToUpdate: 'لا يوجد شيء لتحديثه.',
		changesSaved: 'تم حفظ تغييراتك بنجاح',
		somethingWrongSaving: 'حدث خطأ ما أثناء حفظ تغييراتك.',

		// Custom Domain Settings
		domainTitle: 'النطاق',
		addCustomDomain: 'أضف نطاقك المخصص',
		whiteLabelRunDesc: 'هنا سيتم تشغيل تطبيقك ذي العلامة البيضاء',
		howToSetupWhiteLabel: 'كيفية إعداد نطاق العلامة البيضاء الخاص بك؟',
		domainName: 'اسم النطاق',
		domainPlaceholder: 'app.example.io',
		saveDomain: 'حفظ النطاق',
		cnameInstructions:
			'لربط نطاق مخصص ببوابة الدعم الخاصة بك، تأكد من إضافة سجل CNAME التالي في إعدادات محرر منطقة DNS. يجب أن يكون مسؤول المواقع أو مسؤول الخادم قادرًا على مساعدتك في إعداد ذلك.',
		tableType: 'النوع',
		tableKey: 'المفتاح',
		tableValue: 'القيمة',
		tableSslStatus: 'حالة SSL',
		tableConnectionStatus: 'حالة الاتصال',
		statusActive: 'نشط',
		statusInactive: 'غير نشط',
		copy: 'نسخ',
		cannotSaveHostDomain: 'لا يمكن حفظ نطاقات المضيف كنطاق علامة بيضاء',

		// Manage Workspaces
		workspacesTitle: 'مساحات العمل',
		addNewWorkspace: 'إضافة مساحة عمل جديدة',
		searchWorkspaces: 'البحث في مساحات العمل',
		howToAddWorkspaces: 'كيفية إضافة مساحات عمل جديدة إلى حسابك؟',
		noWorkspacesToShow: 'لا توجد مساحات عمل لعرضها.',
		maxLimitReached: 'تم الوصول إلى الحد الأقصى',
		maxWorkspaceLimit: 'لقد وصلت إلى الحد الأقصى من مساحات العمل لهذه الخطة',
		problemGettingWorkspaces: 'حدثت مشكلة أثناء جلب مساحات العمل الخاصة بك',

		// Invite member (workspace flow)
		inviteMemberTitle: 'دعوة عضو',
		workspaceDetails: 'تفاصيل مساحة العمل',
		inviteTeamMembers: 'دعوة أعضاء الفريق',
		inviteTeamMembersStep: 'دعوة أعضاء الفريق',
		addMoreMembersLater: 'يمكنك دائمًا إضافة المزيد من أعضاء الفريق لاحقًا من إعدادات مساحة العمل.',

		// New workspace detail
		newWorkspace: 'مساحة عمل جديدة',
		howToAddWorkspacesAccount: 'كيفية إضافة مساحات عمل جديدة إلى حسابك.',
		workspaceNamePlaceholder: 'اسم مساحة العمل الخاصة بك',
		saveNext: 'حفظ ومتابعة',

		// Workspace card
		selected: 'محدد',
		createdOn: 'تم الإنشاء في:',
		remove: 'إزالة',
		removeWorkspaceConfirm: 'هل أنت متأكد أنك تريد إزالة مساحة العمل؟',
		cannotDeleteCurrent: 'لا يمكن حذف مساحة العمل المحددة. انتقل إلى مساحة عمل مختلفة ثم قم بإزالتها.',

		// Profile / Account
		accountTitle: 'الحساب',
		deleteAccount: 'حذف الحساب',
		deleteAccountDesc:
			'سيؤدي حذف حسابك إلى حذف وصولك وجميع معلوماتك على هذا الموقع. هل أنت متأكد أنك تريد المتابعة؟',
		updatedProfileSuccess: 'تم تحديث الملف الشخصي بنجاح',
		accountDeletionTitle: 'حذف الحساب',
		deleteAccountConfirm: 'هل تريد حذف حسابك؟',
		btnNo: 'لا',
		btnYes: 'نعم',
		accountDeletedTitle: 'تم حذف الحساب',
		accountDeletedText: 'تم حذف حسابك بنجاح.',
		accountDeletionRelogin: 'إذا كنت تريد حذف حسابك، يرجى تسجيل الدخول مرة أخرى ثم حذف حسابك.',

		// Basic profile fields
		firstName: 'الاسم الأول',
		lastName: 'اسم العائلة',
		email: 'البريد الإلكتروني',
		emailCannotChange: 'لا يمكن تغيير البريد الإلكتروني',

		// Change password
		currentPassword: 'كلمة المرور الحالية',
		invalidPassword: 'كلمة مرور غير صالحة',
		newPassCannotSame: 'لا يمكن أن تكون كلمة المرور الجديدة هي نفسها',
		confirmPassMismatch: 'تأكيد كلمة المرور غير متطابق',

		// Team members
		membersTitle: 'الأعضاء',
		inviteMemberBtn: 'دعوة عضو',
		howToInviteMember: 'كيفية دعوة عضو فريق إلى مساحة العمل الخاصة بك؟',
		noTeamMembers: 'لا يوجد حاليًا أعضاء فريق في مساحة العمل هذه.',
		errorDeletingMember: 'حدث خطأ أثناء حذف العضو',
		deleteMemberConfirm: 'هل أنت متأكد أنك تريد حذف العضو؟',
		invitationLinkGenerated: 'تم إنشاء رابط دعوة لـ %{email}',
		invitationLinkSent: 'تم إرسال رابط دعوة إلى %{email}',
		maxMembersReached: 'لقد وصلت إلى الحد الأقصى من الأعضاء لخطتك',

		// Members card
		searchByNameEmail: 'البحث بالاسم والبريد الإلكتروني',
		inviteLinkCopied: 'تم نسخ رابط الدعوة.',
		noSearchResults: 'لم يتم العثور على نتائج بحث.',

		// Members table
		colName: 'الاسم',
		colRole: 'الدور',
		colStatus: 'الحالة',
		colActions: 'الإجراءات',
		roleManager: 'مدير',
		roleMember: 'عضو',
		roleNotFound: 'الدور غير موجود',
		tooltipEditRole: 'تعديل الدور',
		tooltipDeleteMember: 'حذف عضو الفريق',
		tooltipCopyInviteLink: 'نسخ رابط الدعوة.',

		// Invite member modal
		howToInviteWorkspace: 'كيفية دعوة عضو فريق إلى مساحة العمل؟',
		placeholderFirstName: 'محمد',
		placeholderLastName: 'أحمد',
		placeholderEmailExample: 'mohammed@example.com',
		sendInvitation: 'إرسال الدعوة',
		ownerCannotInvite: 'لا يمكن للمالك دعوة نفسه إلى مساحة العمل.',
		memberEmailExists: 'يوجد بالفعل عضو بهذا البريد الإلكتروني.',

		// Referral
		referAndEarn: 'أحِل واربح',
		earnCommission: 'اربح عمولة متكررة بنسبة 30%!',
		howItWorks: 'إليك كيفية عمل برنامج الشراكة الخاص بنا:',
		step1Join: '1. انضم',
		step2Refer: '2. أحِل',
		step3Earn: '3. اربح',
		joinDesc: 'سجّل في برنامج شركاء CardClan.',
		referDesc: 'شارك رابط الشراكة الفريد الخاص بك مع أصدقائك ومتابعيك.',
		earnDesc: 'احصل على عمولة بنسبة 30% على كل عملية بيع نحصل عليها من رابط الشراكة الخاص بك.',
		noteLabel: 'ملاحظة: ',
		noteText:
			'ليست مجرد تلك الدفعة الواحدة عند تسجيلهم. ستُدفع لك عمولة الـ 30% كل شهر طالما ظل حساب CardClan الخاص بهم نشطًا.',
		becomeAffiliate: 'كن شريكًا',
		createPromoter: 'إنشاء مروّج',
		registerAffiliateDesc: 'استخدم الرابط أدناه لتسجيل نفسك كشريك في CardClan والبدء في الترويج.',
		createPromoterLink: 'إنشاء مروّج',

		// Dropdown
		options: 'خيارات',

		// AI Assistants (MCP)
		mcp_title: 'مساعدو الذكاء الاصطناعي (MCP)',
		mcp_description: 'اربط Claude أو Cursor أو VS Code أو أي مساعد يدعم MCP بحساب CardClan. سيتمكن مساعدك من العثور على البطاقات وإرسالها أو جدولتها للمستلمين وتنظيم المجلدات وعرض تقارير التفاعل، باستخدام حسابك وحدود خطتك.',
		mcp_keyTitle: 'مفتاح API الخاص بك',
		mcp_keyDescription: 'يستخدم المساعد مفتاح API الخاص بك في CardClan للمصادقة (وهو نفس مفتاح التكاملات).',
		mcp_keyWarning: 'يمكن لأي شخص يملك هذا المفتاح إرسال البطاقات من حسابك. احتفظ به سرًا ولا تلصقه في مستندات مشتركة.',
		mcp_generateKey: 'إنشاء مفتاح API',
		mcp_show: 'إظهار',
		mcp_hide: 'إخفاء',
		mcp_copy: 'نسخ',
		mcp_copied: 'تم النسخ إلى الحافظة',
		mcp_urlTitle: 'عنوان الخادم',
		mcp_urlDescription: 'نقطة نهاية MCP الخاصة بـ CardClan (Streamable HTTP).',
		mcp_setupTitle: 'أضف CardClan إلى مساعدك',
		mcp_setupDescription: 'اختر برنامجك وانسخ الإعدادات. يتضمن النص المنسوخ مفتاح API كاملًا.',
		mcp_clientOther: 'برامج أخرى',
		mcp_hint_claudeCode: 'شغّل هذا الأمر في الطرفية.',
		mcp_hint_claudeDesktop: 'افتح الإعدادات ← المطوّر ← تعديل الإعدادات، وادمج هذا في claude_desktop_config.json ثم أعد تشغيل Claude Desktop. يتطلب Node.js.',
		mcp_hint_cursor: 'أضف هذا إلى ‎~/.cursor/mcp.json (أو ‎.cursor/mcp.json داخل المشروع).',
		mcp_hint_vscode: 'أضف هذا إلى ‎.vscode/mcp.json في مساحة العمل، أو شغّل «MCP: Add Server» من لوحة الأوامر.',
		mcp_hint_other: 'يعمل أي برنامج يدعم خوادم MCP البعيدة عبر Streamable HTTP مع ترويسة مخصصة.',
		mcp_tryPrompt: 'جرّب أن تطلب: «اعرض بطاقاتي في CardClan وأرسل بطاقة العيد إلى ann@example.com غدًا الساعة 9 صباحًا». سيعرض مساعدك معاينة للإرسال ويسألك قبل إرسال أي بريد.',
		mcp_toolsTitle: 'ما يمكن لمساعدك فعله',
		mcp_toolsDescription: 'الأدوات المعلّمة بـ«يمكنه إجراء تغييرات» تعدّل حسابك أو ترسل بريدًا؛ ومعظم المساعدين يطلبون موافقتك قبل استخدامها.',
		mcp_readOnly: 'قراءة فقط',
		mcp_makesChanges: 'يمكنه إجراء تغييرات',
		mcp_activityTitle: 'النشاط الأخير',
		mcp_activityDescription: 'كل إجراء تم عبر MCP باستخدام مفتاح API الخاص بك. يُحتفظ به لمدة 90 يومًا.',
		mcp_activityTotal: '%{count} إجراء خلال آخر 90 يومًا',
		mcp_activityEmpty: 'لا يوجد نشاط بعد. بمجرد ربط مساعدك ستظهر إجراءاته هنا.',
		mcp_activityLoadFailed: 'تعذّر تحميل نشاط MCP.',
		mcp_refresh: 'تحديث',
		mcp_loadMore: 'تحميل المزيد',
		mcp_colTime: 'الوقت',
		mcp_colTool: 'الإجراء',
		mcp_colResult: 'النتيجة',
		mcp_colDuration: 'المدة',
		mcp_success: 'نجح',
		mcp_failed: 'فشل',
	} as Record<string, string>,
};
export default settings;
